<script lang="ts">
  import type { CategoryWithSources } from '../../modules/source/source.interface';
  import { createEventDispatcher } from 'svelte';
  import { List, ListItem } from 'svelte-materialify';
  import { querystring, location, push } from 'svelte-spa-router';
  import Scroller from '../Scroller.svelte';
  import PageSidebar from '../PageSidebar.svelte';
  import BackgroundImage from '../BackgroundImage.svelte';

  export let categoriesWithSources: CategoryWithSources[];

  const dispatch = createEventDispatcher();

  $: activeCategoryKey = getActiveCategoryKey($querystring);
  $: allCategoriesWithSources = getAllCategoriesWithSources(categoriesWithSources);
  $: activeCategory = getActiveCategory(activeCategoryKey, allCategoriesWithSources);

  function getAllCategoriesWithSources(
    categoriesWithSources: CategoryWithSources[]
  ): CategoryWithSources[] {
    const totalCountsAndAllSources = categoriesWithSources.reduce(
      (rv, categoryWithSources) => {
        return {
          count: rv.count + categoryWithSources.count,
          sources: [...rv.sources, ...categoryWithSources.sources],
        };
      },
      { sources: [], count: 0 }
    );
    const total: CategoryWithSources = {
      key: 'all',
      name: 'All',
      ...totalCountsAndAllSources,
    };

    return [total, ...categoriesWithSources];
  }

  function getActiveCategoryKey($queryString: string) {
    const queryParams = new URLSearchParams($queryString);
    const categoryKey = queryParams.get('category');

    if (!categoryKey || categoryKey === 'all') {
      return 'all';
    }

    const categoryCounts = categoriesWithSources.find(
      (categorySourceCount) => categorySourceCount.key === categoryKey
    );

    return categoryCounts.key || 'all';
  }

  function getActiveCategory(
    activeCategoryKey: string,
    allCategoriesWithSources: CategoryWithSources[]
  ) {
    return allCategoriesWithSources.find(
      (categoryWithSources) => categoryWithSources.key === activeCategoryKey
    );
  }

  function filterCategory(categoryKey: string) {
    push(`${$location}?category=${categoryKey}`);
  }
</script>

<PageSidebar>
  <List class="elevation-2">
    {#each allCategoriesWithSources as categoryWithSources}
      <ListItem
        active={categoryWithSources.key === activeCategoryKey}
        on:click={() => filterCategory(categoryWithSources.key)}
      >
        {categoryWithSources.name}
        <span slot="append">{categoryWithSources.count}</span>
      </ListItem>
    {/each}
  </List>
</PageSidebar>
<Scroller>
  <List class="pl-6">
    {#each activeCategory.sources as source (source.id)}
      <ListItem on:click={() => dispatch('source-click', source)}>
        <span slot="prepend" class="mr-4">
          <BackgroundImage
            className="elevation-1"
            src={source.image}
            width="30px"
            ratio="1x1"
            radius="100%"
          />
        </span>
        {source.name}
      </ListItem>
    {/each}
  </List>
</Scroller>
